import { API } from './env';
import { axiosInstance } from './httpClient';

// TODO: finish - all the api classes should inherit from this class
export default class BaseApi {
  static API = API;
  static axiosInstance = axiosInstance;

  static getAuthHeaders({ contentType = 'application/json' } = {}) {
    const userInfo = JSON.parse(localStorage.getItem('user'));
    const accessToken = userInfo.token;
    return {
      'Content-Type': contentType,
      Authorization: 'Bearer ' + accessToken,
    };
  }
}
